import Button from "@/shared/form/button";
import { useFiltersByMetaTranslations } from "../utils/use-filters-by-meta-translations";
import { ReloadOutlined } from "@ant-design/icons";
import { useFilter } from "../model/use-filter";

export function ResetFilterButton() {
  const t = useFiltersByMetaTranslations();
  const { reset } = useFilter();

  return (
    <Button type="text" danger icon={<ReloadOutlined />} onClick={reset}>
      {t("Reset filter")}
    </Button>
  );
}
